/**
 * SimpleIcon — bare icon with theme-default colour.
 * Used for non-interactive indicators (clock, menu items).
 */
import { type FC, memo } from "react";
import "../../theme";
import { useUnistyles } from "react-native-unistyles";
import { Icon } from "../Icon";
import type { IconName } from "../../icons/icon-names";

export interface SimpleIconProps {
  readonly name: IconName;
  /** Icon size. Defaults to theme.spacing["6xl"] (24). */
  readonly size?: number;
}

export const SimpleIcon: FC<SimpleIconProps> = memo(function SimpleIcon({ name, size }) {
  const { theme } = useUnistyles();
  return <Icon name={name} size={size ?? theme.spacing["6xl"]} color={theme.colors.icon} />;
});
